module.exports = __webpack_public_path__ + "img/player_serving.48e6f168.png";